<template>
  <div class="pageBox">
    <div class="content">
      <div class="dataBox">
        <el-row class="appInfohBox">
          <el-col :span="24" class="appInfo">
            <div class="imgBox">
              <img class="img" :src="this.appDetail.appIcon" alt=""/>
            </div>
            <div>
              <p class="appName ellipsis"><span :ref='appDetail.appName'>{{ appDetail.appName }}</span></p>
              <p class="flex">应用状态：
                <span v-if="appDetail.freezeState == '1'">正常</span>
                <span v-else class="freezeType">
                  <span v-for="(type,index) in (appDetail.freezeType || '').split('、')" :key="index">{{ type }} </span>
                </span>
              </p>
            </div>
            <div class="border"></div>
            <div>
              <p class="ellipsis">包名：
                <span :ref='appDetail.appPackage'>{{ appDetail.appPackage }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="contentBox">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="概况" name="overview">
            <overview v-if="activeName=='overview'"></overview>
          </el-tab-pane>

          <el-tab-pane label="链接访问" name="linkAccess">
            <linkAccess v-if="activeName=='linkAccess'"></linkAccess>
          </el-tab-pane>

          <el-tab-pane label="链接分发" name="linkDistribute">
            <linkDistribute v-if="activeName=='linkDistribute'"></linkDistribute>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import overview from "./template/overview.vue"
import linkAccess from "./template/linkAccess.vue"
import linkDistribute from "./template/linkDistribute.vue"
export default {
  components: {overview,linkAccess,linkDistribute},
  data(){
    return{
      activeName:"overview",
      appDetail:{},
    }
  },
  created(){
    this.queryIdentifyLastDetail();
  },
  methods:{
    //获取应用信息
    queryIdentifyLastDetail(){
      this.$apis.consoleSever.queryDetail({
        id:this.$route.query.appId,
      }).then(res=>{
        if (res.code == 0) {
          this.appDetail=res.data;

        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .content {
    padding: 30px;
    background: #fff;
    box-shadow: $--background-shadow-base;
    overflow: hidden;
    .dataBox{
      .appInfohBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .appInfo {
          display: flex;
          align-items: center;
          height: 100px;

          & > div {
            height: 100%;
            display: flex;
            flex-direction: column;

            p {
              margin-bottom: 10px;
              font-size: 16px;
              height: 30px;
              line-height: 30px;
            }
          }

          .border {
            width: 1px;
            height: 100px;
            margin: 0 20px;
            background: #ccc;
          }

          .imgBox {
            width: 100px;
            height: 100px;
            border-radius: 10px;
            margin-right: 19px;

            .img {
              width: 100%;
              height: 100%;
            }
          }

          .appName {
            max-width: 220px;
            font-size: 24px;
            color: #000000;
            font-weight: bold;
          }
          .freezeType {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
}
</style>
